import React, { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSheetInterface,
  SKILLS,
} from "@dndModels";

import CharacterSkillInput from "@dndComponents/character/skills/CharacterSkillInput";
import CharacterSkillsButton from "@dndComponents/character/skills/CharacterSkillsButton";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  shared: boolean;
}

export default function CharacterSkills({ 
  character,
  char_interface,
  shared,
}: Props) {
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
  
  return (
    <Grid className="curved_border bg_black_transp">
      <div className="centered">
        <Grid container spacing={0} direction="row" 
          style={{
            width: "95%"
          }}>
          <Grid
            size={{
              xs: 12
            }}>
            <CharacterSkillsButton
              character={character}
              char_interface={char_interface}
              disabled={shared}
            />
          </Grid>
          { SKILLS.sort((a,b) => { return a.name.localeCompare(b.name); }).map(skill => {
            return (
              <Grid
                key={skill._id}
                size={{
                  xs: 12
                }}>
                <CharacterSkillInput
                  character={character}
                  char_interface={char_interface}
                  skill={skill}
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Grid>
  );
}
